<template>
  <div class='lib__form__main' data-cy='result-step-component'>
    <div class='lib__form__main__content'>
      <div v-if='finalBatteryRechargingCapacity && getHasSolarPanels'
        class='lib__card lib__card--relief green_card solar-panel lib__feedback'>

        <div class='lib__feedback__icon'>
          <img :src="require('@/assets/e-mobility/Icon-SolarPanel.svg')" alt='result-time-icon' class='filter-white'
            style='padding-top: 10px'>
        </div>
        <div class='lib__feedback__content'>
          {{ $t('e-mobility.result.solarPanelsTitle') }}
        </div>
      </div>
    </div>
    <div class='lib__form__main__content'>
      <div v-if='finalBatteryRechargingCapacity' class='lib__card lib__card--relief'>
        <div class='row center-xs'>
          <div class='col-xs-12 col-sm-10'>
            <div v-if='getHasSolarPanels' class='lib__card-section solar-panel'>
              {{ $t('e-mobility.result.solarPanelsWarning') }}
            </div>
            <div v-else class='lib__card-section'>
              <img :src="require('@/assets/e-mobility/Icon-result-ok.svg')" alt='result-ok-icon'>
              <p class='lib__card-title'>{{ $t('e-mobility.result.goodNewsTitle') }}</p>
              <span>{{ $t('e-mobility.result.happyDescription') }}</span>
            </div>
            <div class='lib__card-section'>
              <img :src="require('@/assets/e-mobility/Icon-result-time.svg')" alt='result-time-icon'>
              <p class='lib__card-title'>{{ getChargingDuration }} {{ $t('e-mobility.result.hours') }}</p>
              <span>{{ $t('e-mobility.result.hoursDescription') }}
                <span @click='onHoursModalClick'>
                  <i class='fas fa-info-circle lib__clickable-tooltips'></i>
                </span>
              </span>
            </div>
            <div class='lib__card-section'>
              <img v-if='isDayIcon' :src="require('@/assets/e-mobility/Icon-result-day.svg')" alt='result-day-icon'>
              <img v-else :src="require('@/assets/e-mobility/Icon-result-night.svg')" alt='result-night-icon'>
              <p class='lib__card-title'>{{ getPeriod }}</p>
              <span>{{ $t('e-mobility.result.dayDescription') }}
                <span @click='onPeriodModalClick'>
                  <i class='fas fa-info-circle lib__clickable-tooltips'></i>
                </span>
              </span>
            </div>
            <div class='lib__card-section'>
              <template v-if='isElectricalCar'>
                <img :src="require('@/assets/e-mobility/Icon-result-borne.svg')" alt='result-borne-icon'>
                <p class='lib__card-title'>{{ getChargerPower }} {{ $t('e-mobility.result.kW') }}</p>
                <span>{{ $t('e-mobility.result.kWDescription', {
                  electricityType: getChargerPowerExtraInfo,
                  power: getPowerInfo
                }) }}</span>
              </template>
              <template v-else>
                <img :src="require('@/assets/e-mobility/Icon-hybride.svg')" alt='result-hybrid-icon'>
                <p class='lib__card-title'>{{ getChargerPower }} {{ $t('e-mobility.result.kW') }}</p>
                <span>{{ $t('e-mobility.result.hybridDescription') }}
                  <span @click='onHybridModalClick'>
                    <i class='fas fa-info-circle lib__clickable-tooltips'></i>
                  </span>
                </span>
              </template>
            </div>
            <Feedback v-if='hasMonophased' icon level='alert' tiny>
              <p>{{ $t('e-mobility.result.exceptionExplanation') }}</p>
            </Feedback>
            <div>
              <a :href="$t('e-mobility.result.calculationExplanationLink').toString()"
                class='lib__text-secondary lib__text-weight-700' target='_blank'
                @click='trackClickCalculationExplanation'>{{
                  $t('e-mobility.result.calculationExplanationLabel') }}</a>
            </div>
          </div>
        </div>
      </div>
      <div v-else class='lib__card lib__card--relief'>
        <div class='row center-xs'>
          <div class='col-xs-11'>
            <img :src="require('@/assets/e-mobility/Icon-result-error.svg')" alt='result-error-icon'>
            <p class='lib__card-title'>{{ $t('e-mobility.result.insufficientPowerTitle') }}</p>
            <p
              v-html="$t('e-mobility.result.insufficientDescription', { electricityType: getChargerPowerExtraInfo, power: getPowerInfo })">
            </p>
            <div>
              <a :href="$t('e-mobility.result.calculationExplanationLink').toString()"
                class='lib__text-secondary lib__text-weight-700' target='_blank'
                @click='trackClickCalculationExplanation'>{{
                  $t('e-mobility.result.calculationExplanationLabel') }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class='lib__card lib__card--relief lib__text-center'>
        <div class='lib__card-section'>
          <p class='lib__card-title'>{{ $t('e-mobility.result.smartChargerTitle') }}</p>
        </div>
        <div class='lib__card-section'>
          <p v-html="$t('e-mobility.result.smartChargerText')"></p>
        </div>

        <a :href="$t('e-mobility.result.smartChargerLink').toString()"
          class='lib__btn lib__btn--outline lib__btn--rounded' target='_blank' @click='trackClickSmartCharger'>{{
            $t('e-mobility.result.smartChargerLinkLabel') }}</a>
      </div>

      <Feedback v-if='finalBatteryRechargingCapacity' class='lib__card' icon='far fa-comment-alt' level='secondary'>
        <h3>{{ $t('e-mobility.result.oldVisitTip') }}</h3>
      </Feedback>
      <div v-if='finalBatteryRechargingCapacity' class='lib__card lib__card--relief lib__text-center'>
        <div class='lib__card-section'>
          <p class='lib__card-title'>{{ $t('e-mobility.result.alternativeTitle') }}</p>
        </div>
        <div class='lib__card-section'>
          <p v-if='isAnyAlternative'
            v-html="$t('e-mobility.result.alternativeText', { electricityType: getChargerPowerExtraInfo, power: getPowerInfo, borne: finalBatteryRechargingCapacity[1].chargerPower, time: finalBatteryRechargingCapacity[1].chargingDuration })">
          </p>
        </div>
        <div class='lib__card-section'>
          <p>{{ $t('e-mobility.result.quoteInfo') }}</p>
        </div>
        <a :href="$t('e-mobility.result.quoteLink').toString()" class='lib__btn lib__btn--outline lib__btn--rounded'
          target='_blank'>{{ $t('e-mobility.result.quoteButtonLabel') }}</a>
        <p>{{ $t('e-mobility.result.priceInformation') }}
          <span @click='onPriceModalClick'>
            <i class='fas fa-info-circle lib__clickable-tooltips'></i>
          </span>
        </p>
      </div>
      <div v-else class='lib__card lib__card--relief lib__text-center'>
        <p class='lib__card-title'>{{ $t('e-mobility.result.solutionTitle') }}</p>
        <div class='lib__card-section'>
          <p v-html="$t('e-mobility.result.solutionDescription')"></p>
        </div>
        <a :href="$t('e-mobility.result.quoteLink').toString()" class='lib__btn lib__btn--outline lib__btn--rounded'
          target='_blank' @click='trackClick'>{{ $t('e-mobility.result.quoteButtonLabel') }}</a>
        <p>{{ $t('e-mobility.result.priceInformation') }}
          <span @click='onPriceModalClick'>
            <i class='fas fa-info-circle lib__clickable-tooltips'></i>
          </span>
        </p>
      </div>
      <div class='row center-xs lib__field'>
        <div class='col-xs-12'>
          <i class='far fa-envelope lib__text-secondary lib__panel__header__icon' />
          <a class='lib__text-secondary lib__text-weight-700' href='' @click.prevent='onEmailModalClick'>{{
            $t('e-mobility.result.sendSimulation') }}</a>
        </div>
      </div>
    </div>
    <ModalDialog :closeable="$t('common.close')" :open.sync='isHybridModalOpen' size='default'>
      <div>
        <img :src="require('@/assets/e-mobility/Icon-hybride.svg')" alt='icon-hybrid'>
      </div>
      <p v-html="$t('e-mobility.result.hybridModal.part1')"></p>
      <p v-html="$t('e-mobility.result.hybridModal.part2')"></p>
      <p v-html="$t('e-mobility.result.hybridModal.part3')"></p>
    </ModalDialog>
    <ModalDialog :closeable="$t('common.close')" :open.sync='isHoursModalOpen' size='default'>
      <div>
        <img :src="require('@/assets/e-mobility/Icon-battery.svg')" alt='icon-battery'>
      </div>
      <p v-html="$t('e-mobility.result.hoursModal')"></p>
    </ModalDialog>
    <ModalDialog :closeable="$t('common.close')" :open.sync='isPeriodModalOpen' size='default'>
      <div>
        <img :src="require('@/assets/e-mobility/Icon-periode.svg')" alt='icon-period'>
      </div>
      <p v-html="$t('e-mobility.result.perioModal.part1')"></p>
      <p v-html="$t('e-mobility.result.perioModal.part2')"></p>
      <p v-html="$t('e-mobility.result.perioModal.part3')"></p>
    </ModalDialog>
    <power-increase-packages-modal v-model="isPriceModalOpen" :isLoading="packagesLoading" />
    <ModalDialog :closeable="$t('common.close')" :open.sync='isSendEmailModalOpen' size='medium'>
      <ValidationObserver ref='validator' slim>
        <p class='lib__text-center' v-html="$t('e-mobility.result.emailInformation')"></p>
        <text-box v-model='email' :label="$t('contact.form.email')" email required></text-box>
        <Recaptcha :site-key='siteKey' v-if='!stateToken' :key='recaptchaKey' v-model='recaptchaToken'
          :by-pass='$testMode' />
        <Feedback v-if='emailSent' icon level='success' simple>
          <p>{{ $t('e-mobility.result.emailSent') }}</p>
        </Feedback>
        <div v-if='!emailSent' class='lib__text-center'>
          <button :class="[{ 'lib__btn--loading': loading }]" class='lib__btn lib__btn--primary lib__btn--rounded'
            type='button' @click='onSendEmailClick'>{{ $t('e-mobility.result.sendLabel') }}
          </button>
        </div>
      </ValidationObserver>
    </ModalDialog>
  </div>
</template>

<script lang='ts'>
import {
  BatteryRechargingCapacity,
  CarSpecification,
  CarType,
  CheckEanSearch,
  ConsumingDevice,
  DayPeriod,
  ElectricityInstallation,
  ElectricityPowerSupplyType,
  ElectricMobilityCustomerEmailRequest,
  ElectricMobilityGridAccessPointInfo,
  ElectricVehicle,
  GetPackagesRequest,
  PowerIncreasePackages
} from '@/models'
import { BatteryRechargingCapacityState } from '@/store/e-mobility/battery-recharging-capacity/types'
import { AxiosResponse } from 'axios'
import Component from 'vue-class-component'
import { Getter, Mutation, State } from 'vuex-class'
import Step from '../Step'
import PowerIncreasePackagesModal from '@/components/display/EMobility/PowerIncreasePackagesModal.vue'

@Component({
  name: 'result-step',
  components: {
    PowerIncreasePackagesModal
  }
})
export default class ResultStep extends Step {
  //#region [Data]
  @State('batteryResult', { namespace: 'eMobility/batteryRechargingCapacity' })
  public stateBatteryRechargingCapacity!: BatteryRechargingCapacityState
  @State('electricityInstallation', { namespace: 'eMobility/electricityInstallation' })
  public stateElectricityInstallation!: ElectricityInstallation
  @State('hasEan', { namespace: 'eMobility/identification' })
  public stateHasEan!: string
  @State('gridAccessPointInfo', { namespace: 'eMobility/identification' })
  public stateGridAccessPointInfo!: ElectricMobilityGridAccessPointInfo | null
  @State('token', { namespace: 'eMobility/identification' })
  public stateToken!: string | null
  @State('carSpecification', { namespace: 'eMobility/carSpecification' })
  public stateCarSpecification!: CarSpecification
  @State('requestId', { namespace: 'eMobility' })
  public requestId!: string
  @State('consumingDeviceSelection', { namespace: 'eMobility/consumingDevices' })
  public stateConsumingDeviceSelection!: ConsumingDevice[]
  @State('electricVehicle', { namespace: 'eMobility/carSpecification' })
  public stateElectricVehicle!: ElectricVehicle | null

  @Getter('getEanCode', { namespace: 'eMobility/identification' })
  public getEanCode!: string

  public finalBatteryRechargingCapacity: BatteryRechargingCapacity[] | null = null
  public email: string | null = null
  public emailSent: boolean = false

  public isHybridModalOpen: boolean = false
  public isHoursModalOpen: boolean = false
  public isPeriodModalOpen: boolean = false
  public isPriceModalOpen: boolean = false
  public isSendEmailModalOpen: boolean = false

  public recaptchaToken: string | null = null
  public loading: boolean = false
  public isIdentified: boolean = false
  public recaptchaKey: number = 0

  public packagesLoading: boolean = false
  //#endregion

  //#region [Mutation]
  @Mutation('STORE_TOKEN', { namespace: 'eMobility/identification' })
  public storeToken!: (index: string | null) => void

  @Mutation('STORE', { namespace: 'eMobility/powerIncreasePackages' })
  public storePackages!: (data: PowerIncreasePackages | null) => void
  //#endregion

  //region [Computed]
  public get siteKey() {
    return process.env.VUE_APP_CAPTCHA_SITE_KEY
  }
  public get getChargingDuration() {
    if (this.finalBatteryRechargingCapacity) {
      return this.finalBatteryRechargingCapacity[0].chargingDuration
    }
  }

  public get getHasSolarPanels() {
    if (this.stateConsumingDeviceSelection) {
      return this.stateConsumingDeviceSelection.some((d) => d.device === 'SolarPanel')
    }
    return false
  }

  public get getPeriod() {
    if (this.finalBatteryRechargingCapacity) {
      return this.finalBatteryRechargingCapacity[0].period === DayPeriod.day
        ? this.$t('e-mobility.result.day')
        : this.$t('e-mobility.result.night')
    }
  }

  public get isDayIcon() {
    if (this.finalBatteryRechargingCapacity) {
      return this.finalBatteryRechargingCapacity[0].period === DayPeriod.day
    }
  }

  public get isElectricalCar() {
    return this.stateCarSpecification.carType === CarType.electric
  }

  public get getChargerPower() {
    if (this.finalBatteryRechargingCapacity) {
      return this.finalBatteryRechargingCapacity[0].chargerPower
    }
  }

  public get getChargerPowerExtraInfo() {
    const data: ElectricityPowerSupplyType | null =
      this.stateHasEan === 'yes' && this.stateGridAccessPointInfo?.electricMobilityMeterInfos
        ? this.stateGridAccessPointInfo.electricMobilityMeterInfos[0].electricityPowerSupplyType
        : this.stateElectricityInstallation.electricityPowerSupplyType

    switch (data) {
      case ElectricityPowerSupplyType.monophase:
        return this.$t('e-mobility.result.phase.mono')
      case ElectricityPowerSupplyType.triphase:
        return this.$t('e-mobility.result.phase.three')
      case ElectricityPowerSupplyType.tetraphase:
        return this.$t('e-mobility.result.phase.tetra')
    }
  }

  public get getPowerInfo() {
    return this.stateHasEan === 'yes' && this.stateGridAccessPointInfo?.electricMobilityMeterInfos
      ? this.stateGridAccessPointInfo.electricMobilityMeterInfos[0].amperage
      : this.stateElectricityInstallation.power
  }

  public get isAnyAlternative() {
    return this.finalBatteryRechargingCapacity && this.finalBatteryRechargingCapacity.length > 1
  }

  public get hasMonophased() {
    const data: ElectricityPowerSupplyType | null =
      this.stateHasEan === 'yes' && this.stateGridAccessPointInfo?.electricMobilityMeterInfos
        ? this.stateGridAccessPointInfo.electricMobilityMeterInfos[0].electricityPowerSupplyType
        : this.stateElectricityInstallation.electricityPowerSupplyType

    return data === ElectricityPowerSupplyType.monophase
  }

  public get getElectricityPowerSupplyType() {
    return this.stateHasEan === 'yes' && this.stateGridAccessPointInfo?.electricMobilityMeterInfos
      ? this.stateGridAccessPointInfo.electricMobilityMeterInfos[0].electricityPowerSupplyType!
      : this.stateElectricityInstallation.electricityPowerSupplyType!
  }

  public get getAmperage() {
    return this.stateHasEan === 'yes' && this.stateGridAccessPointInfo?.electricMobilityMeterInfos
      ? this.stateGridAccessPointInfo.electricMobilityMeterInfos[0].amperage!
      : this.stateElectricityInstallation.power!
  }

  //#endregion

  //#region [Method]
  public mounted() {
    this.loadPackages()
    if (this.stateBatteryRechargingCapacity && this.stateBatteryRechargingCapacity.batteryResult) {
      const data = this.stateBatteryRechargingCapacity.batteryResult
      let temp = this.stateBatteryRechargingCapacity.batteryResult

      for (let i = 0; i < data.length; i++) {
        if (this.hasMonophased && data[i].chargerPower === 11) {
          temp = temp.filter((c) => c !== data[i])
        }
        if (i + 1 < data.length) {
          if (
            data[i].chargingDuration === data[i + 1].chargingDuration &&
            data[i].chargerPower === data[i + 1].chargerPower &&
            data[i].period === DayPeriod.day &&
            data[i + 1].period === DayPeriod.night
          ) {
            temp = temp.filter((c) => c !== data[i])
          }
        }
      }
      temp.sort((x, y) => y.chargingDuration - x.chargingDuration)
      temp = temp.splice(0, 2)

      this.finalBatteryRechargingCapacity = temp.length ? temp : null
    } else {
      this.finalBatteryRechargingCapacity = null
    }

    const firstResult = this.finalBatteryRechargingCapacity && this.finalBatteryRechargingCapacity.length > 0 ?
      this.finalBatteryRechargingCapacity[0] : null

    const secondResult = this.isAnyAlternative ? this.finalBatteryRechargingCapacity![1] : null

    this.$appInsights.trackEvent('EMobility_ResultStep', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      CarModelKnown: !!this.stateElectricVehicle ? 'true' : 'false',
      BatteryCapacity: this.stateCarSpecification!.batteryCapacity!.toString(),
      Ean: this.getEanCode,
      Result: this.isAnyAlternative
        ? 'TwoOrMoreResult'
        : this.finalBatteryRechargingCapacity
          ? 'OneResult'
          : 'InsufficientPower',
      Period1: firstResult?.period?.toString() ?? '',
      ChargingDuration1: firstResult?.chargingDuration?.toString() ?? '',
      ChargerPower1: firstResult?.chargerPower?.toString() ?? '',
      Period2: secondResult?.period?.toString() ?? '',
      ChargingDuration2: secondResult?.chargingDuration?.toString() ?? '',
      ChargerPower2: secondResult?.chargerPower?.toString() ?? ''
    })
  }

  public async loadPackages() {
    this.packagesLoading = true
    const data: GetPackagesRequest = {
      amperage: this.getAmperage,
      powerSupplyType: this.getElectricityPowerSupplyType
    }
    const result = await this.$api.post<PowerIncreasePackages>(`api/ElectricMobility/packages`, data)
    this.storePackages(result.data)
    this.packagesLoading = false
  }

  public async sendEmail(data: ElectricMobilityCustomerEmailRequest): Promise<void | null> {
    try {
      this.loading = true
      let token = this.stateToken

      if (!token) {
        if (!this.recaptchaToken) {
          throw new Error('No recaptcha token found')
        }

        const responseToken = await this.$api.get<string>(`electricMobility/token`, {
          headers: { 'g-recaptcha-response': this.recaptchaToken },
          cache: {
            cachePredicate: (status) => true,
          }
        })
        token = responseToken.data
        this.storeToken(responseToken.data)
      }

      const response = await this.$api.post<void>(
        `api/ElectricMobility`,
        data,
        {
          headers: {
            Authorization: token
          },
          cache: {
            cachePredicate: (status) => true,
          }
        }
      )

      this.emailSent = response.status === 204
    } catch (err) {
      return null
    } finally {
      this.isSendEmailModalOpen = this.emailSent
      this.loading = false
    }
  }

  public onHybridModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'HybridResult'
    })
    this.isHybridModalOpen = !this.isHybridModalOpen
  }

  public onHoursModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'HoursResult'
    })
    this.isHoursModalOpen = !this.isHoursModalOpen
  }

  public onPeriodModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'PeriodResult'
    })
    this.isPeriodModalOpen = !this.isPeriodModalOpen
  }

  public onPriceModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'PriceResult'
    })
    this.isPriceModalOpen = !this.isPriceModalOpen
  }

  public onEmailModalClick(): void {
    this.emailSent = false
    this.isSendEmailModalOpen = !this.isSendEmailModalOpen
  }

  public async onSendEmailClick(): Promise<void> {
    this.$appInsights.trackEvent('EMobility_EmailSent', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Result: this.isAnyAlternative
        ? 'TwoOrMoreResult'
        : this.finalBatteryRechargingCapacity
          ? 'OneResult'
          : 'InsufficientPower'
    })
    const isValid = await this.$validatorObs.validate()
    if (isValid) {
      this.emailSent = false
      if (this.email) {
        const mainCapacity = this.finalBatteryRechargingCapacity ? this.finalBatteryRechargingCapacity[0] : null
        const alternateCapacity =
          this.isAnyAlternative && this.finalBatteryRechargingCapacity ? this.finalBatteryRechargingCapacity[1] : null
        const data: ElectricMobilityCustomerEmailRequest | null = {
          email: this.email.trim(),
          hasSolarPanels: this.getHasSolarPanels,
          electricityPowerSupplyType: this.getElectricityPowerSupplyType,
          power: this.getPowerInfo!,
          carType: this.stateCarSpecification.carType!,
          mainCapacity,
          alternateCapacity
        }

        this.sendEmail(data)
      }
    }
  }

  public trackClick(): void {
    this.$appInsights.trackEvent('EMobility_linkClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Link: 'DemandeDevis',
      Result: this.isAnyAlternative
        ? 'TwoOrMoreResult'
        : this.finalBatteryRechargingCapacity
          ? 'OneResult'
          : 'InsufficientPower'
    })
  }

  public trackClickSmartCharger(): void {
    this.$appInsights.trackEvent('EMobility_linkClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Link: 'Decouvrir plus infos'
    })
  }

  public trackClickCalculationExplanation(): void {
    this.$appInsights.trackEvent('EMobility_linkClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Link: 'Comment est calcule ce restultat?'
    })
  }

  //#endregion
}
</script>
<style scoped>
.green_card {
  background-color: #97bf0d;
  color: white;
}

.filter-white {
  filter: brightness(0) invert(1);
}

.solar-panel {
  font-size: 1.6rem;
}
</style>
